// Cart Note Handler
document.addEventListener('DOMContentLoaded', function() {
  initCartNoteHandler();
});

function initCartNoteHandler() {
  const cartNote = document.getElementById('cart-note');
  if (!cartNote) return;
  
  // Check on page load if textarea has content
  checkIfFilled();
  
  // Add event listeners
  cartNote.addEventListener('focus', handleFocus);
  cartNote.addEventListener('blur', handleBlur);
  cartNote.addEventListener('input', checkIfFilled);
  
  function handleFocus() {
    // No need to add class as the CSS already handles :focus
  }
  
  function handleBlur() {
    checkIfFilled();
  }
  
  function checkIfFilled() {
    if (cartNote.value.trim() !== '') {
      cartNote.classList.add('form-field-filled');
    } else {
      cartNote.classList.remove('form-field-filled');
    }
  }
} 